import PropTypes from 'prop-types';

import { StyledTable, StyledTableContainer } from '../../OrderHistory.style';
import { orderRow } from '../../utils/proptypes';
import OrderTable from '../OrderTable';

const TABLE_HEADER = [
  {
    title: 'Product',
  },
  {
    title: 'Fulfillment Status',
    isStatusColumn: true,
  },
  {
    title: 'Order Date',
  },
];

export default function OrderHistoryContainer({ rows }) {
  return (
    <StyledTableContainer>
      <StyledTable>
        <caption
          style={{
            position: 'absolute',
            left: '-10000px',
            top: 'auto',
            width: '1px',
            height: '1px',
            overflow: 'hidden',
          }}
        >
          Order history displaying product name, fulfillment status, and order date
        </caption>
        <thead>
          <tr>
            {TABLE_HEADER.map(({ title, isStatusColumn }) => (
              <th key={title} {...(isStatusColumn && { 'data-status-column': true })}>
                {title}
              </th>
            ))}
          </tr>
        </thead>
        <OrderTable rows={rows} />
      </StyledTable>
    </StyledTableContainer>
  );
}

OrderHistoryContainer.propTypes = {
  rows: PropTypes.arrayOf(orderRow).isRequired,
};
